import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter, Route } from 'react-router-dom';
import store from './stores';
import { route } from './components/App';

import LanguageProvider from './LanguageProvider';

const RootComponent = () => (
  <LanguageProvider>
    <Provider store={store}>
      <BrowserRouter>
        <Route {...route} />
      </BrowserRouter>
    </Provider>
  </LanguageProvider>
);

export default RootComponent;